/* unplugin-vue-components disabled */import { render } from "./w-input.vue?vue&type=template&id=15fce188&ts=true"
import script from "./w-input.vue?vue&type=script&lang=ts"
export * from "./w-input.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__